import { WarehouseFundraiserPayout } from "../../Interfaces/Warehouse";
import { formatCurrencyWithCommas } from "../../CommonFunctions";
import React from "react";
type FundraiserPayoutTableProps = {
  payout: WarehouseFundraiserPayout;
};

export const FundraiserPayoutTable: React.FC<FundraiserPayoutTableProps> = ({
  payout,
}) => {
  return (
    <div className="warehouse-order-page-items-needed-table">
      <table className="warehouse-order-table">
        <thead>
          <tr>
            <th>Total Collected</th>
            <th>MamFam Profit</th>
            <th>Total Amount Owed</th>
            <th>Total Paid So Far</th>
            <th>Total Paid Remaining</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{formatCurrencyWithCommas(payout.total_collected)}</td>
            <td>{formatCurrencyWithCommas(payout.mamfam_profit)}</td>
            <td>{formatCurrencyWithCommas(payout.total_amount_owed)}</td>
            <td>{formatCurrencyWithCommas(payout.total_paid_so_far)}</td>
            <td>{formatCurrencyWithCommas(payout.total_paid_remaining)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default FundraiserPayoutTable;
